export const MaterialFeedbackIconClass = {
    critical: {
        icon: 'icon-error-severe',
        iconColor: 'text-danger',
        background: 'alert-danger',
    },
    alert: {
        icon: 'icon-error-severe',
        iconColor: 'text-danger',
        background: 'alert-danger',
    },
    warning: {
        icon: 'icon-Warning-important',
        iconColor: 'text-warning',
        background: 'alert-warning',
    },
    info: {
        icon: 'icon-info',
        iconColor: 'text-info',
        background: 'alert-info',
    },
    success: {
        icon: 'icon-tick-circle',
        iconColor: 'text-success',
        background: 'alert-success',
    },
};

export enum MaterialFeedbackInfoLevel {
    critical = 0,
    alert = 1,
    warning = 2,
    info = 3,
    success = 4,
}
